module.exports = __webpack_public_path__ + "static/media/world-map.bf85f115.png";